import { FC, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SimpleTextbox from "../simple-textbox";
import useFormBinder from "lib/hooks/useFormBinder";

interface SimpleTimePickerProps {
  isSingle?: boolean;
  onChange?: (value: WorkingTime) => void;
  value?: WorkingTime;
  disabled?: boolean;
}

const SimpleTimePicker: FC<SimpleTimePickerProps> = ({
  isSingle = false,
  value,
  disabled,
  onChange,
}) => {
  const selectedTimes: WorkingTime = { fromTime: null, toTime: null };
  const { values, handleChange, setValues } = useFormBinder(
    value || selectedTimes
  );

  useEffect(() => {
    if (!value) {
      setValues({ fromTime: null, toTime: null });
    }
  }, [value]);

  useEffect(() => {
    if (isSingle) {
      onChange?.(values);
    } else {
      if (values.fromTime && values.toTime) {
        // If both fromTime and toTime are selected, call onChange with both values
        onChange?.(values);
      }
    }
  }, [values]);

  if (isSingle) {
    return (
      <Row className="mt-3">
        <Col sm="12">
          <SimpleTextbox
            disabled={disabled}
            name="fromTime"
            id="fromTime"
            label="Select Time"
            type="time"
            onChange={handleChange}
            value={values.fromTime}
            required
          />
        </Col>
      </Row>
    );
  }

  const getToTimeValue = (): string => {
    if (values.toTime) {
      return values.toTime > values.fromTime ? values.toTime : values.fromTime;
    } else {
      return values.fromTime ? values.fromTime : "";
    }
  };

  return (
    <Row className="mt-3">
      <Col sm="6">
        <SimpleTextbox
          disabled={disabled}
          name="fromTime"
          id="fromTime"
          label="From Time"
          type="time"
          onChange={handleChange}
          value={values.fromTime ?? ""}
          required
        />
      </Col>
      <Col sm="6">
        <SimpleTextbox
          disabled={disabled}
          name="toTime"
          id="toTime"
          label="To Time"
          type="time"
          onChange={handleChange}
          value={getToTimeValue()}
          required
        />
      </Col>
    </Row>
  );
};

export default SimpleTimePicker;
